<template>
  <div class="mat">
    <div class="sec-head">
      <div>
        <span class="eyebrow">Everything in one place</span>
        <h2>Your Material</h2>
        <p>
          Your course book, templates and reference material — open directly
          here or in a new tab.
        </p>
      </div>
    </div>
    <div class="docs">
      <DocumentCard v-for="d in course.documents" :key="d.id" :doc="d" />
    </div>
    <div class="lit">
      <div class="lit-head">
        <b>Recommended reading</b>
        <span>Available in your local library</span>
      </div>
      <ul>
        <li v-for="l in course.literature" :key="l.id">
          <b>{{ l.title }}</b>
          <span>{{ l.author }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import DocumentCard from './DocumentCard.vue'

export default {
  name: 'MaterialsSection',
  components: {
    DocumentCard
  },
  props: {
    course: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.sec-head {
  margin-bottom: 18px;
}
.eyebrow {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--teal-dk);
}
h2 {
  font-size: 1.55rem;
  letter-spacing: -0.01em;
  margin: 4px 0 6px;
}
.sec-head p {
  color: var(--ink-soft);
  font-size: 0.95rem;
  margin: 0;
}
.docs {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 14px;
}
.lit {
  margin-top: 22px;
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 16px 18px;
  background: var(--white);
}
.lit-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.lit-head b {
  font-size: 0.98rem;
}
.lit-head span {
  font-size: 0.8rem;
  color: var(--ink-soft);
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
li {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: var(--paper);
}
li b {
  font-size: 0.92rem;
}
li span {
  font-size: 0.8rem;
  color: var(--ink-soft);
}
</style>
